import Helpers from "@sistemas.mundo/helper-functions";

const validarDependenciaOtroCampo = (x, getValues, setError) => {
  if (x.dependency) {
    if (!getValues(x.dependency.name)) {
      setError(x.name, {
        type: "dependency",
        message: Helpers.formErrorMessages.dependency(
          x.dependency.label,
          x.type
        ),
      });
      return false;
    }
  }
  return true;
};

/**
 * Muestra el campo si el campo dependiente se ha seleccionado o ingresado y cumpla con el valor especificado
 * @param {*} x
 * @param {*} getValues
 * @param {*} setError
 */
const showIf = (x, getValues) => {
  if (x.showIf) {
    if (x.showIf.value) {
      if (getValues(x.showIf.name)) {
        if (x.showIf.type === "autocomplete") {
          if (x.showIf.multiple) {
            return getValues(x.showIf.name).find(
              (selectVal) => selectVal.id === x.showIf.value
            )
              ? true
              : false;
          }
          return getValues(x.showIf.name).id === x.showIf.value ? true : false;
        } else {
          return getValues(x.showIf.name) === x.showIf.value ? true : false;
        }
      }
      return getValues(x.showIf.name) &&
        getValues(x.showIf.name) === x.showIf.value
        ? true
        : false;
    } else {
      return getValues(x.showIf.name) ? true : false;
    }
  }
  return true;
};

/**
 * Valida que el campo sea mayor que el indicado
 * @param {*} x
 * @param {*} getValues
 * @param {*} setError
 * @returns
 */
const validarMayorQue = (x, getValues, setError) => {
  if (x.mayorQue && getValues(x.mayorQue.name)) {
    switch (x.type) {
      case "date":
        if (
          !Helpers.date.isHigher(getValues(x.name), getValues(x.mayorQue.name))
        ) {
          setError(x.name, {
            type: "dependency",
            message: Helpers.formErrorMessages.mayorQue(x.mayorQue.label),
          });
          return false;
        }
        break;
      case "time":
        if (
          !Helpers.date.isTimeHigher(
            getValues(x.name),
            getValues(x.mayorQue.name)
          )
        ) {
          setError(x.name, {
            type: "dependency",
            message: Helpers.formErrorMessages.mayorQue(x.mayorQue.label),
          });
          return false;
        }
        break;
      case "number":
        if (getValues(x.name) < getValues(x.mayorQue.name)) {
          setError(x.name, {
            type: "dependency",
            message: Helpers.formErrorMessages.mayorQue(x.mayorQue.label),
          });
          return false;
        }
        break;
      default:
        break;
    }
  }
  return true;
};

const validarTipoCampo = (x, getValues, setError, setValue, clearErrors) => {
  switch (x.type) {
    case "text":
    case "phone":
    case "password":
    case "email":
    case "textarea":
    case "rut":
    case "number":
    case "date":
      return revalidarCampo(x, getValues, setValue, setError, clearErrors);
    default:
      return true;
  }
};

const revalidarCampo = (x, getValues, setValue, setError, clearErrors) => {
  if (!getValues(x.name)) {
    clearErrors(x.name);
    return true;
  }
  if (x.type === "date") {
    if (
      !Helpers.date.isValidDate(
        Helpers.date.formatDateString(getValues(x.name), "YYYY/MM/DD")
      )
    ) {
      setError(x.name, {
        type: "invalid",
        message: "Fecha inválida",
      });
      return false;
    } else {
      clearErrors(x.name);
      return true;
    }
  } else {
    if (
      getValues(x.name) &&
      validatePattern(x, getValues, setError) &&
      validateMinLength(x, getValues, setError) &&
      validateMaxLength(x, getValues, setError) &&
      validarMayorQue(x, getValues, setError) &&
      menorQue(x, getValues, setError) &&
      validarDependenciaOtroCampo(x, getValues, setError) &&
      validateRut(x, getValues, setError, setValue) &&
      validateNumber(x, getValues, setError)
    ) {
      clearErrors(x.name);
      return true;
    }
  }
  return false;
};

const validateRut = (x, getValues, setError, setValue) => {
  if (x.type === "rut") {
    if (getValues(x.name)) {
      const rutValido = Helpers.rut.validarRut(getValues(x.name));

      if (!rutValido.valid) {
        setError(x.name, {
          type: "invalid",
          message: x.errorMessage ?? "RUT inválido",
        });
        return false;
      }
      if (rutValido.rut.length > 10) {
        setError(x.name, {
          type: "invalid",
          message: "Rut excede el tamaño máximo",
        });
        return false;
      }
      setValue(x.name, rutValido.rut);
    }
  }
  return true;
};

const validateNumber = (x, getValues, setError) => {
  if (x.type === "number") {
    if (!Helpers.number.isNumeric(getValues(x.name))) {
      setError(x.name, {
        type: "invalid",
        message: x.errorMessage ?? "Debe ingresar un valor númerico",
      });
      return false;
    }
  }
  return true;
};

/**
 * Valida si existe un minimo de caracteres, retorna true en caso de que se afirmativa la validación
 * @param {*} x
 * @param {*} getValues
 * @param {*} setError
 * @returns
 */
const validateMinLength = (x, getValues, setError) => {
  if (x.minLength && x.minLength > getValues(x.name).length) {
    setError(x.name, {
      type: "invalid",
      message: Helpers.formErrorMessages.minLength(
        x.type === "number" ? "number" : "text",
        x.minLength
      ),
    });
    return false;
  }
  return true;
};

/**
 * Valida si existe un maximo de caracteres, retorna true en caso de que se afirmativa la validación
 * @param {*} x
 * @param {*} getValues
 * @param {*} setError
 * @returns
 */
const validateMaxLength = (x, getValues, setError) => {
  if (x.maxLength && x.maxLength < getValues(x.name).length) {
    setError(x.name, {
      type: "invalid",
      message: Helpers.formErrorMessages.maxLength(
        x.type === "number" ? "number" : "text",
        x.maxLength
      ),
    });
    return false;
  }
  return true;
};

/**
 * Valida el pattern del campo
 * @param {*} x
 * @param {*} getValues
 * @param {*} setError
 * @returns
 */
const validatePattern = (x, getValues, setError) => {
  const pattern = x.pattern ?? getDefaultPatternByType(x.type);
  if (pattern && !pattern.test(getValues(x.name))) {
    setError(x.name, {
      type: "invalid",
      message:
        x.errorMessage ??
        Helpers.formErrorMessages.patternErrorMessage(
          Helpers.string.replaceAll(x.label, "*", "")
        ),
    });
    return false;
  }
  return true;
};

const getDefaultPatternByType = (type) => {
  switch (type) {
    case "text":
      return Helpers.formPatterns.texto;
    case "textarea":
      return Helpers.formPatterns.textoExplicacion;
    case "email":
      return Helpers.formPatterns.email;
    case "number":
      return Helpers.formPatterns.numero;
    case "telefono":
      return Helpers.formPatterns.telefono;
    case "codigoOferta":
      return Helpers.formPatterns.codigoOferta;
    default:
      break;
  }
};

/**
 * Valida que el campo sea menor que el indicado
 * @param {*} x
 * @param {*} getValues
 * @param {*} setError
 * @returns
 */
const menorQue = (x, getValues, setError) => {
  if (x.menorQue && getValues(x.menorQue.name)) {
    switch (x.type) {
      case "date":
        if (
          !Helpers.date.isLower(getValues(x.name), getValues(x.menorQue.name))
        ) {
          setError(x.name, {
            type: "dependency",
            message: Helpers.formErrorMessages.menorQue(x.menorQue.label),
          });
          return false;
        }
        break;
      case "time":
        if (
          !Helpers.date.isTimeLower(
            getValues(x.name),
            getValues(x.menorQue.name)
          )
        ) {
          setError(x.name, {
            type: "dependency",
            message: Helpers.formErrorMessages.menorQue(x.menorQue.label),
          });
          return false;
        }
        break;

      case "number":
        if (
          Helpers.number.isNumeric(getValues(x.name)) &&
          Helpers.number.isNumeric(getValues(x.menorQue.name))
        ) {
          const valorInicial = getValues(x.name);
          const valorFinal = getValues(x.menorQue.name);
          if (parseInt(valorInicial) > parseInt(valorFinal)) {
            setError(x.name, {
              type: "dependency",
              message: Helpers.formErrorMessages.menorQue(x.menorQue.label),
            });
            return false;
          }
        }
        break;
      default:
        break;
    }
  }
  return true;
};

/**
 * Verifica si el campo es UploadFile y es requerido
 * @param {*} element
 * @returns
 */
const validateRequiredUploadFile = (
  element,
  getValues,
  setError,
  clearErrors
) => {
  const valorUpload = getValues(element.name);
  if (element.type.toLowerCase() === "file" && element.required) {
    if (Array.isArray(valorUpload) && valorUpload.length > 0) {
      clearErrors(element.name);
      return true;
    } else {
      setError(element.name, {
        type: "required",
        message: `${Helpers.string.replaceAll(element.label)} requerido`,
      });
      return false;
    }
  }
  return true;
};

const dinamicFormValidations = {
  validarTipoCampo: validarTipoCampo,
  menorQue: menorQue,
  validarMayorQue: validarMayorQue,
  validarDependenciaOtroCampo: validarDependenciaOtroCampo,
  showIf: showIf,
  validateRequiredUploadFile: validateRequiredUploadFile,
};

export default dinamicFormValidations;
